module.exports = __webpack_public_path__ + "static/media/cover3.45908041.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover3.png
// module id = 556
// module chunks = 0